import { Box, Typography, useMediaQuery } from '@mui/material'
import React, { useState } from 'react'
import { ReactComponent as EnterSvg } from "./en.svg";
import { ReactComponent as ProfSvg } from "./prof.svg";
import { Motion } from '../Motion/Motion';
import { Link } from 'react-router-dom';
import { LogAnalytics } from '../../Classes/firebase';


export default function PartnersLine({ appPageData, bgcolor = "#F3F8FF" }) {
    const [logged, setLogged] = useState(false);
    const mobile = useMediaQuery('(max-width:900px)');

    const Enterprises = () => {
        const editedIcon = React.cloneElement(<EnterSvg />, {
            style: {
                maxHeight: mobile ? "40px" : '48px',
                maxWidth: mobile ? "160px" : '192px',
            },
        });
        return <>{editedIcon}</>;
    };

    const Profaktura = () => {
        const editedIcon = React.cloneElement(<ProfSvg />, {
            style: {
                maxHeight: mobile ? "40px" : '48px',
                maxWidth: mobile ? "160px" : '192px',
            },
        });
        return <>{editedIcon}</>;
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', py: { xs: '40px', sm: '40px', md: '60px' }, bgcolor }}>
            {!mobile && <Typography variant='big' sx={{ mr: '50px' }}>Partneři:</Typography>}
            <Box sx={{ pr: '40px' }}>
                <Motion>
                    <Box sx={{
                        cursor: 'pointer',
                        display: 'flex', alignItems: 'center', alignContent: 'center'
                    }} >
                        <Link style={{ height: '40px' }} to={"https://metastreamenterprises.cz/"} target='blank' onClick={() => {
                            if (logged) return;
                            LogAnalytics("click_partner", { partner: 'metastreamenterprises' });
                            setLogged(true);
                        }}><Enterprises /></Link>
                    </Box>
                </Motion>
            </Box>
            <Motion>
                <Box sx={{
                    cursor: 'pointer',
                    display: 'flex', alignItems: 'center', alignContent: 'center'

                }}>
                    <Link style={{ height: '40px' }} to={"https://profaktura.cz/"} target='blank' onClick={() => {
                        if (logged) return;
                        LogAnalytics("click_partner", { partner: 'profaktura' });
                        setLogged(true);
                    }}><Profaktura /></Link>
                </Box>
            </Motion>
        </Box>
    )
}
